import React from "react";
import clsx from "clsx";
import { RoundIconButtonProps } from "interfaces/round_icon_button.interface";
import "./round_icon_button.ui.scss";

const RoundIconButton = (props: RoundIconButtonProps): React.ReactElement => {
  const { icon, label, onClick, isIconFlipped = false, className } = props;

  return (
    <button type="button" className={clsx("round_icon_button", className)} aria-label={label} title={label} onClick={onClick}>
      <img className={clsx("round_icon_button_icon", isIconFlipped && "round_icon_button_icon_flipped")} src={icon} alt="" />
    </button>
  );
};

export default RoundIconButton;
